import React from 'react';
import RodLiftStatusRegisterTable from './RodLiftStatusRegisterTable';
import Loader from '../../features/common/Loader/Loader';
import { useAppSelector } from '../../hooks/storeHooks';
import TableHeader from '../data-tables/TableHeader';

const RodLiftWellStatusRegisterWidget: React.FC = () => {
  const isRodliftwellStatusLoading = useAppSelector((state: any) => state.rodliftwellstatus?.loading ?? false);
  const rodliftwellstatusData = useAppSelector((state: any) => state.rodliftwellstatus?.data?.wellStatusOverview || '');

  return (
    <main className='main-container table-wrap'>
      <TableHeader title={`Bufflehead well VFD`} />
      {isRodliftwellStatusLoading ? (
        <div className='flex justify-center items-center py-10'>
          <Loader />
        </div>
      ) : rodliftwellstatusData.length > 0 ? (
        <RodLiftStatusRegisterTable data={rodliftwellstatusData} />
      ) : (
        <div className='no-matching-records-container text-center p-4 pl-6 pr-6'>
          <span className='no-matching-records-message'>No records found</span>
        </div>
      )}
    </main>
  );
};

export default RodLiftWellStatusRegisterWidget;
